import {
    publish as headerPublish,
    subscribe as headerSubscribe,
    unsubscribe as headerUnsubscribe,
    hasSubscriber as headerHasSubscriber,
    publishAndWait as  headerPublishAndWait,
    NavigationServiceImpl, StateServiceImpl,
    UIServiceImpl, UserServiceImpl
} from './services';
import { publishAndWaitTimeout, PubSubMessages, headerDetails } from '../config';
import { HeaderEvents, SessionExpiredData, Project } from 'navigator-header';
import { publish, subscribe } from 'ert-framebus';
import { wrapWithLogger } from '../utils/logger';
import { loggerFactory } from 'ert-logger';

const logger = loggerFactory.createLogger('Global Header/header.object.ts');

subscribe(PubSubMessages.logoutEvent, (done: () => void) => {
    headerPublishAndWait(HeaderEvents.logout, publishAndWaitTimeout).then(done, done);
});

subscribe(PubSubMessages.sessionExpired, (done: (data: SessionExpiredData) => void) => {
    const data: SessionExpiredData = {
        destinationUrl: location.href
    };
    const doneProxy = () => {
        done(data);
    };
    headerPublishAndWait(HeaderEvents.sessionExpired, publishAndWaitTimeout, [data]).then(doneProxy, doneProxy);
});

export function createHeader() {
    const navigationService = new NavigationServiceImpl();
    const stateService = new StateServiceImpl();
    const uiService = new UIServiceImpl();
    const userService = new UserServiceImpl();

    return wrapWithLogger({
        details: headerDetails,

        publish: headerPublish,

        subscribe: headerSubscribe,

        unsubscribe: headerUnsubscribe,

        hasSubscriber: headerHasSubscriber,

        publishAndWait:  headerPublishAndWait,

        navigation: navigationService,

        state: stateService,

        ui: uiService,

        user: userService,

        navigateToStudy: navigationService.navigateToStudy,

        redirect: navigationService.navigateByUseCase,

        createState: stateService.createState,

        setState: stateService.setState,

        createStateByStudyNumber: stateService.createStateByStudyNumber,

        addDropdown: uiService.addDropdown,

        removeWidget: uiService.removeDropdown,

        registerClientRoot: uiService.registerClientRoot,

        addBreadcrumbs: uiService.setBreadcrumbs,

        addStudyContextLink(): void {
            /* empty */
        },

        updateUserProfile: userService.updateUserProfile,

        clearCachedStudies: userService.clearCachedStudies,

        logout: userService.logout,

        show(): void {
            /* empty */
        },

        cacheGetStudy(projectId: string, productCode: string, cb: (project: Project) => void, errorCb?: (error: any) => void): void {
            publish(PubSubMessages.cacheGetStudy, projectId, productCode, cb, errorCb);
        },

        cacheGetStudyByStudyNumber(studyNumber: string, cb: (project: Project) => void, errorCb?: (error: any) => void): void {
            publish(PubSubMessages.cacheGetStudyByStudyNumber, studyNumber, cb, errorCb);
        },

        setProductTitle(title: string): void {
            publish(PubSubMessages.setProductTitle, title);
        },

        rendered(cb: Function): void {
            headerSubscribe(HeaderEvents.afterRender, cb, true);
        }
    }, logger);
}
